import { Field } from 'formik';
import styled from 'styled-components';

import { Input } from 'components/Forms/Inputs';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
`;

const FieldRow = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const FieldWrapper = styled.div`
  width: 200px;
  .ant-row {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
  }
  .ant-form-item {
    margin-bottom: 0px;
  }
  .ant-form-item-explain {
    position: absolute;
    margin-top: 31px;
  }
`;

const PurchasingDepartmentForm = () => {
  return (
    <>
      <Wrapper>
        <div>
          <b>Purchasing Department Contact Information:</b> <i>Optional</i>
        </div>
      </Wrapper>
      <FieldRow>
        <FieldWrapper>
          <Field
            component={Input}
            autoComplete="none"
            name="pointOfContact"
            label="Point of Contact"
          />
        </FieldWrapper>
        <FieldWrapper>
          <Field
            component={Input}
            placeholder="To Receive Order Confirmation"
            autoComplete="none"
            name="confirmationEmail"
            label="Point of Contact Email"
          />
        </FieldWrapper>
      </FieldRow>
    </>
  );
};

export default PurchasingDepartmentForm;
